import Error from '../Error/Error';
import Loading from '../Loading/Loading';
import Show from '../Show/Show';
import { DataType, useFetchedTree } from '../../hooks/content/useFetchedTree';
import { FC, PropsWithChildren } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

interface TreeFetchProps extends PropsWithChildren {
  dataId: string;
  dataType: DataType;
  pathId?: string;
  reckoningId?: string;
  fromPath?: boolean;
  fromReckoning?: boolean;
}

const _TreeFetch: FC<TreeFetchProps> = ({
  children,
  dataId,
  dataType,
  pathId,
  reckoningId,
  fromPath,
  fromReckoning,
}) => {
  const rootStore = useStores();

  const tree = rootStore.trees.getTree(dataId);

  // Cold load: initial load when tree.data doesn't exist yet (show full-screen loading)
  // Hot reload: reloading when tree.data already exists (allow children to render, Session handles loading UI)
  const isColdLoad = !tree.data && !tree.error;
  const isHotReload = tree.loading && tree.data !== undefined;

  const loading = isColdLoad || rootStore.session.state === 'pending';
  const error = tree.error || rootStore.session.state === 'error';

  useFetchedTree({
    dataId,
    dataType,
    pathId,
    reckoningId,
    fromPath,
    fromReckoning,
  });
  console.log('TreeFetch.render', {
    dataId,
    dataType,
    loading,
    error,
    isColdLoad,
    isHotReload,
    sessionState: rootStore.session.state,
    treeLoading: tree.loading,
  });

  if (!dataId) {
    return null;
  }

  return (
    <>
      <Show when={loading}>
        <Loading />
      </Show>
      <Show when={!loading}>
        <Show when={error} keyed>
          {error => {
            console.error(error);
            return (
              <Error labels={{GENERIC: rootStore.language?.translate?.MOBILE?.ERROR?.GENERIC}} />
            );
          }}
        </Show>
        <Show when={!error && tree.data}>
          {children}
        </Show>
      </Show>
    </>
  );
};
export const TreeFetch = observer(_TreeFetch);
